module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/59d4bb932f52f637d8cb0228e85c44f0.png";